<template>
  <main class="bg-ip-color-1 pb-4 md:pt-10">
    <div class="max-w-md mx-auto">
      <div class="relative bg-ip-color-3 text-white rounded-b-2xl md:rounded-t-2xl">
        <div class="relative z-10 flex flex-col gap-5 pt-2 pb-4">
          <div class="opacity-0 profile-item mx-auto">
            <div class="bg-ip-color-5 rounded-full w-fit overflow-clip">
              <figure class="text-ip-color-4">
                <img :src="selectedUser?.photo" class="max-w-[7.5rem]" alt="">
              </figure>
            </div>
          </div>
          <div class="opacity-0 profile-item space-y-2">
            <div class="text-center text-2xl font-semibold">{{ selectedUser?.name }}</div>
            <div class="text-center text-base">{{ selectedUser?.role }}</div>
          </div>
          <div class="opacity-0 profile-item flex items-center justify-center">
            <NuxtLink :to="`/qr-${route.params.profileLink}`" class="py-1 relative z-10 h-6 w-full overflow-clip">
              <div class="h-4 max-w-xs w-full relative"></div>
              <div class="absolute top-2 h-48 w-full -translate-y-1/2">
                <div class="arrow arrow-first"></div>
                <div class="arrow arrow-second"></div>
              </div>
            </NuxtLink>
          </div>
        </div>
        <div class="opacity-0 profile-graphic absolute top-4 max-w-[5.2rem] touch-none select-none">
          <ArrowDouble/>
        </div>
      </div>
      <div class="px-6 py-6 space-y-4">
        <!-- email -->
        <div @click="copyEmail(selectedUser?.email)" class="opacity-0 profile-item group flex justify-between items-center cursor-pointer inner-shadow">
          <div class="flex items-center gap-4">
            <div class=" bg-ip-color-2 rounded-lg p-2">
              <svg class="text-ip-color-3 w-8 h-8 group-hover:scale-105 transition-all duration-300" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 8L10.8906 13.2604C11.5624 13.7083 12.4376 13.7083 13.1094 13.2604L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="relative text-base overflow-hidden w-full text-ip-color-3">
              <div :class="emailCopied ? '-translate-y-6':'translate-y-0'" class="relative transition-all duration-300 w-full">{{ selectedUser?.email }}</div>
              <div :class="emailCopied ? 'translate-y-0':'translate-y-6'" class="absolute top-0 left-0 transition-all duration-300">Copied!</div>
            </div>
          </div>
          <div class="relative">
            <svg :class="emailCopied ? 'rotate-180 opacity-0':'rotate-0 opacity-100'" class="w-6 h-6 text-ip-color-3 group-hover:translate-x-1 transition-all duration-300 ease-out" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1276_3107)">
              <path d="M13 20C14.3256 19.9984 15.5964 19.4711 16.5338 18.5338C17.4711 17.5965 17.9984 16.3256 18 15V6.24302C18.0016 5.71738 17.8988 5.19665 17.6976 4.71104C17.4964 4.22542 17.2008 3.78456 16.828 3.41402L14.586 1.17202C14.2155 0.799191 13.7746 0.50362 13.289 0.302438C12.8034 0.101255 12.2826 -0.00153795 11.757 1.73896e-05H7C5.6744 0.00160525 4.40356 0.528899 3.46622 1.46624C2.52888 2.40358 2.00159 3.67442 2 5.00002V15C2.00159 16.3256 2.52888 17.5965 3.46622 18.5338C4.40356 19.4711 5.6744 19.9984 7 20H13ZM4 15V5.00002C4 4.20437 4.31607 3.44131 4.87868 2.8787C5.44129 2.31609 6.20435 2.00002 7 2.00002C7 2.00002 11.919 2.01402 12 2.02402V4.00002C12 4.53045 12.2107 5.03916 12.5858 5.41423C12.9609 5.7893 13.4696 6.00002 14 6.00002H15.976C15.986 6.08102 16 15 16 15C16 15.7957 15.6839 16.5587 15.1213 17.1213C14.5587 17.6839 13.7956 18 13 18H7C6.20435 18 5.44129 17.6839 4.87868 17.1213C4.31607 16.5587 4 15.7957 4 15ZM22 8.00002V19C21.9984 20.3256 21.4711 21.5965 20.5338 22.5338C19.5964 23.4711 18.3256 23.9984 17 24H8C7.73478 24 7.48043 23.8947 7.29289 23.7071C7.10536 23.5196 7 23.2652 7 23C7 22.7348 7.10536 22.4804 7.29289 22.2929C7.48043 22.1054 7.73478 22 8 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7957 20 19V8.00002C20 7.7348 20.1054 7.48045 20.2929 7.29291C20.4804 7.10537 20.7348 7.00002 21 7.00002C21.2652 7.00002 21.5196 7.10537 21.7071 7.29291C21.8946 7.48045 22 7.7348 22 8.00002Z" fill="currentColor"/>
              </g>
              <defs>
              <clipPath id="clip0_1276_3107">
              <rect width="24" height="24" fill="white"/>
              </clipPath>
              </defs>
            </svg>
            <svg :class="emailCopied ? 'rotate-0 opacity-100':'-rotate-180 opacity-0'" xmlns="http://www.w3.org/2000/svg" class="text-ip-color-3 absolute top-0 left-0 w-7 h-7 group-hover:translate-x-1 transition-all duration-300 ease-out" viewBox="0 0 24 24"><path fill="currentColor" d="M20 8.94a1.31 1.31 0 0 0-.06-.27v-.09a1.07 1.07 0 0 0-.19-.28l-6-6a1.07 1.07 0 0 0-.28-.19a.32.32 0 0 0-.09 0a.88.88 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V9zm-6-3.53L16.59 8H15a1 1 0 0 1-1-1ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3Zm-3.71-6.71L11 15.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 1.42 0l4-4a1 1 0 0 0-1.42-1.42"/></svg>
          </div>
        </div>

        <!-- tel -->
        <div @click="copyPhone(selectedUser?.phone)" class="opacity-0 profile-item hidden lg:flex group justify-between items-center cursor-pointer inner-shadow">
          <div class="text-base flex items-center gap-4">
            <div class=" bg-ip-color-2 rounded-lg p-2">
              <svg class="text-ip-color-3 w-8 h-8 group-hover:scale-105 transition-all duration-300" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 5C3 3.89543 3.89543 3 5 3H8.27924C8.70967 3 9.09181 3.27543 9.22792 3.68377L10.7257 8.17721C10.8831 8.64932 10.6694 9.16531 10.2243 9.38787L7.96701 10.5165C9.06925 12.9612 11.0388 14.9308 13.4835 16.033L14.6121 13.7757C14.8347 13.3306 15.3507 13.1169 15.8228 13.2743L20.3162 14.7721C20.7246 14.9082 21 15.2903 21 15.7208V19C21 20.1046 20.1046 21 19 21H18C9.71573 21 3 14.2843 3 6V5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="relative text-base overflow-hidden text-ip-color-3">
              <div :class="phoneCopied ? '-translate-y-6':'translate-y-0'" class="relative transition-all duration-300">{{ selectedUser?.phone }}</div>
              <div :class="phoneCopied ? 'translate-y-0':'translate-y-6'" class="absolute top-0 left-0 transition-all duration-300">Copied!</div>
            </div>
          </div>
          <div class="relative">
            <svg :class="phoneCopied ? 'rotate-180 opacity-0':'rotate-0 opacity-100'" class="w-6 h-6 text-ip-color-3 group-hover:translate-x-1 transition-all duration-300 ease-out" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1276_3107)">
              <path d="M13 20C14.3256 19.9984 15.5964 19.4711 16.5338 18.5338C17.4711 17.5965 17.9984 16.3256 18 15V6.24302C18.0016 5.71738 17.8988 5.19665 17.6976 4.71104C17.4964 4.22542 17.2008 3.78456 16.828 3.41402L14.586 1.17202C14.2155 0.799191 13.7746 0.50362 13.289 0.302438C12.8034 0.101255 12.2826 -0.00153795 11.757 1.73896e-05H7C5.6744 0.00160525 4.40356 0.528899 3.46622 1.46624C2.52888 2.40358 2.00159 3.67442 2 5.00002V15C2.00159 16.3256 2.52888 17.5965 3.46622 18.5338C4.40356 19.4711 5.6744 19.9984 7 20H13ZM4 15V5.00002C4 4.20437 4.31607 3.44131 4.87868 2.8787C5.44129 2.31609 6.20435 2.00002 7 2.00002C7 2.00002 11.919 2.01402 12 2.02402V4.00002C12 4.53045 12.2107 5.03916 12.5858 5.41423C12.9609 5.7893 13.4696 6.00002 14 6.00002H15.976C15.986 6.08102 16 15 16 15C16 15.7957 15.6839 16.5587 15.1213 17.1213C14.5587 17.6839 13.7956 18 13 18H7C6.20435 18 5.44129 17.6839 4.87868 17.1213C4.31607 16.5587 4 15.7957 4 15ZM22 8.00002V19C21.9984 20.3256 21.4711 21.5965 20.5338 22.5338C19.5964 23.4711 18.3256 23.9984 17 24H8C7.73478 24 7.48043 23.8947 7.29289 23.7071C7.10536 23.5196 7 23.2652 7 23C7 22.7348 7.10536 22.4804 7.29289 22.2929C7.48043 22.1054 7.73478 22 8 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7957 20 19V8.00002C20 7.7348 20.1054 7.48045 20.2929 7.29291C20.4804 7.10537 20.7348 7.00002 21 7.00002C21.2652 7.00002 21.5196 7.10537 21.7071 7.29291C21.8946 7.48045 22 7.7348 22 8.00002Z" fill="currentColor"/>
              </g>
              <defs>
              <clipPath id="clip0_1276_3107">
              <rect width="24" height="24" fill="white"/>
              </clipPath>
              </defs>
            </svg>
            <svg :class="phoneCopied ? 'rotate-0 opacity-100':'-rotate-180 opacity-0'" xmlns="http://www.w3.org/2000/svg" class="text-ip-color-3 absolute top-0 left-0 w-7 h-7 group-hover:translate-x-1 transition-all duration-300 ease-out" viewBox="0 0 24 24"><path fill="currentColor" d="M20 8.94a1.31 1.31 0 0 0-.06-.27v-.09a1.07 1.07 0 0 0-.19-.28l-6-6a1.07 1.07 0 0 0-.28-.19a.32.32 0 0 0-.09 0a.88.88 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V9zm-6-3.53L16.59 8H15a1 1 0 0 1-1-1ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3Zm-3.71-6.71L11 15.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 1.42 0l4-4a1 1 0 0 0-1.42-1.42"/></svg>
          </div>
        </div>
        <a :href="`tel:${selectedUser?.phone}`" class="opacity-0 profile-item lg:hidden group flex justify-between items-center cursor-pointer inner-shadow">
          <div class="text-base flex items-center gap-4">
            <div class=" bg-ip-color-2 rounded-lg p-2">
              <svg class="text-ip-color-3 w-8 h-8 group-hover:scale-105 transition-all duration-300" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 5C3 3.89543 3.89543 3 5 3H8.27924C8.70967 3 9.09181 3.27543 9.22792 3.68377L10.7257 8.17721C10.8831 8.64932 10.6694 9.16531 10.2243 9.38787L7.96701 10.5165C9.06925 12.9612 11.0388 14.9308 13.4835 16.033L14.6121 13.7757C14.8347 13.3306 15.3507 13.1169 15.8228 13.2743L20.3162 14.7721C20.7246 14.9082 21 15.2903 21 15.7208V19C21 20.1046 20.1046 21 19 21H18C9.71573 21 3 14.2843 3 6V5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="text-ip-color-3">{{ selectedUser?.phone }}</div>
          </div>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-6 h-6 text-ip-color-3 group-hover:translate-x-1 transition-all duration-300">
              <path fill-rule="evenodd" d="M5.22 14.78a.75.75 0 0 0 1.06 0l7.22-7.22v5.69a.75.75 0 0 0 1.5 0v-7.5a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0 0 1.5h5.69l-7.22 7.22a.75.75 0 0 0 0 1.06Z" clip-rule="evenodd" />
            </svg>
          </div>
        </a>

        <!-- web -->
        <div @click="goToLink('https://impacthink.id')" class="opacity-0 profile-item group flex justify-between items-center cursor-pointer inner-shadow">
          <div class="text-base flex items-center gap-4">
            <div class=" bg-ip-color-2 rounded-lg p-2">
              <svg class="text-ip-color-3 w-8 h-8 group-hover:scale-105 transition-all duration-300" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M21 12H3M12 21C7.02944 21 3 16.9706 3 12M12 21C13.6569 21 15 16.9706 15 12C15 7.02944 13.6569 3 12 3M12 21C10.3431 21 9 16.9706 9 12C9 7.02944 10.3431 3 12 3M3 12C3 7.02944 7.02944 3 12 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="text-ip-color-3">https://impacthink.id</div>
          </div>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-6 h-6 text-ip-color-3 group-hover:translate-x-1 transition-all duration-300">
              <path fill-rule="evenodd" d="M5.22 14.78a.75.75 0 0 0 1.06 0l7.22-7.22v5.69a.75.75 0 0 0 1.5 0v-7.5a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0 0 1.5h5.69l-7.22 7.22a.75.75 0 0 0 0 1.06Z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

        <!-- linked -->
        <div @click="goToLink('https://www.linkedin.com/in/impacthink-indonesia-8561a62b0/')" class="opacity-0 profile-item group flex justify-between items-center cursor-pointer inner-shadow">
          <div class="text-base flex items-center gap-4">
            <div class=" bg-ip-color-2 rounded-lg p-2">
              <svg xmlns="http://www.w3.org/2000/svg" class="text-ip-color-3 w-8 h-8 group-hover:scale-105 transition-all duration-300" viewBox="0 0 14 14"><path fill="currentColor" fill-rule="evenodd" d="M2.913 2.362c.26-.268.403-.626.4-.998A1.417 1.417 0 0 0 1.928 0A1.428 1.428 0 0 0 .532 1.364a1.449 1.449 0 0 0 1.396 1.428a1.42 1.42 0 0 0 .985-.43M1.67 4.63c-.587-.013-.987-.022-.987.696v7.992c0 .703.382.689.932.668c.1-.004.205-.008.314-.008c.11 0 .215.004.314.008c.548.02.922.035.922-.668V5.327c0-.718-.392-.71-.976-.696a11.321 11.321 0 0 1-.519 0Zm4.084.015c-.266.053-.437.223-.437.681v7.992c0 .703.367.689.918.668c.1-.004.207-.008.318-.008c.112 0 .218.004.319.008c.554.02.928.035.928-.668V9.056a1.545 1.545 0 0 1 1.577-1.695a1.534 1.534 0 0 1 1.62 1.663v4.261c0 .704.366.69.917.669c.1-.004.207-.008.318-.008c.112 0 .218.004.319.008c.551.02.917.035.917-.668V7.83a3.195 3.195 0 0 0-3.388-3.335a2.674 2.674 0 0 0-2.387 1.066c.011-.394-.117-.916-.436-.916c-.092 0-.233-.005-.393-.01c-.4-.012-.92-.028-1.11.01" clip-rule="evenodd"/></svg>
            </div>
            <div class="text-ip-color-3">ImpacThink Indonesia</div>
          </div>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-6 h-6 text-ip-color-3 group-hover:translate-x-1 transition-all duration-300">
              <path fill-rule="evenodd" d="M5.22 14.78a.75.75 0 0 0 1.06 0l7.22-7.22v5.69a.75.75 0 0 0 1.5 0v-7.5a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0 0 1.5h5.69l-7.22 7.22a.75.75 0 0 0 0 1.06Z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>

      </div>
    </div>
  </main>

  <div class="bg-ip-color-1 w-full">
    <div class="opacity-0 profile-item max-w-md mx-auto sticky bottom-4 md:bottom-6 z-50 w-full px-2">
      <div class="bg-ip-offwhite border border-gray-100 bg-opacity-60 backdrop-blur-lg flex justify-between gap-3 items-center px-3 py-3 shadow-sm rounded-[16px]">
        <figure class="max-w-[7.5rem]">
          <img src="/images/logo.png" alt="">
        </figure>
        <div v-if="isInstagramBrowser && isIphoneDevice" class="tooltip tooltip-open flex-shrink-0" data-tip="Long press to save">
          <a :href="`https://impacthink.id/api/download-vcard/?slug=${selectedUser?.slug}`" Download class="inline-block flex-shrink-0 relative w-fit group">
            <div class="absolute w-full h-full bg-ip-color-3 bg-opacity-5 group-hover:scale-y-125 group-hover:scale-x-105 rounded-lg transition-all duration-300"></div>
            <div
              class="relative bg-ip-color-3 z-10 text-sm font-semibold text-white focus:outline-none shadow-lg hover:shadow-md hover:bg-opacity-95 py-2 px-[.65rem] rounded-lg flex gap-2 items-center transition-all duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
              Save Contact
            </div>
          </a>
        </div>
        <a v-else :href="`https://impacthink.id/api/download-vcard/?slug=${selectedUser?.slug}`" Download class="inline-block flex-shrink-0 relative w-fit group">
          <div class="absolute w-full h-full bg-ip-color-3 bg-opacity-5 group-hover:scale-y-125 group-hover:scale-x-105 rounded-lg transition-all duration-300"></div>
          <div
            class="relative bg-ip-color-3 z-10 text-sm font-semibold text-white focus:outline-none shadow-lg hover:shadow-md hover:bg-opacity-95 py-2 px-[.65rem] rounded-lg flex gap-2 items-center transition-all duration-300">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
            Save Contact
          </div>
        </a>
      </div>
    </div>
  </div>

</template>

<script setup>
const { $anime } = useNuxtApp();
const route = useRoute();
const router = useRouter();
const config = useRuntimeConfig();

const isInstagramBrowser = ref(false);
const isIphoneDevice = ref(false);

const user = ref([
  {
    photo: '/images/impacthink/lisa.webp',
    name: 'Lisa Imrani',
    first_name: 'Lisa',
    last_name: 'Imrani',
    role: 'Managing Director',
    email: 'lisa@impacthink.id',
    phone: '+6281224799623',
    company: 'Impacthink.id',
    website: 'https://impacthink.id',
    slug: 'lisa',
    notes: 'Managing Director at Impacthink.id.',
  },

  {
    photo: '/images/impacthink/nadia.webp',
    name: 'Nadia Andayani',
    first_name: 'Nadia',
    last_name: 'Andayani',
    role: 'Strategy Director',
    email: 'nadia@impacthink.id',
    phone: '+6281380007982',
    company: 'Impacthink.id',
    website: 'https://impacthink.id',
    slug: 'nadia',
    notes: 'Strategy Director at Impacthink.id.',
  },

  {
    photo: '/images/impacthink/farida.webp',
    name: 'Farida Soemawidjaja',
    first_name: 'Farida',
    last_name: 'Soemawidjaja',
    role: 'Director',
    email: 'farida@impacthink.id',
    phone: '+6285883386914',
    company: 'Impacthink.id',
    website: 'https://impacthink.id',
    slug: 'farida',
    notes: 'Director at Impacthink.id.',
  },

  {
    photo: '/images/impacthink/lia.webp',
    name: 'Lia Handayani',
    first_name: 'Lia',
    last_name: 'Handayani',
    role: 'Marketing Director',
    email: 'lia@impacthink.id',
    phone: '+62818916973',
    company: 'Impacthink.id',
    website: 'https://impacthink.id',
    slug: 'lia',
    notes: 'Marketing Director at Impacthink.id.',
  },
]);
const selectedUser = computed(() => user.value.find((user) => user.slug === route.params.profileLink));

const emailCopied = ref(false);
const copyEmail = (email) => {
  navigator.clipboard.writeText(email).then(function () {
    emailCopied.value = true;
    const to = setTimeout(() => {
      emailCopied.value = false;
      clearTimeout(to);
    }, 3000);
  }, function (err) {
    console.error('Async: Could not copy text: ', err);
  });
};

const phoneCopied = ref(false);
const copyPhone = (phoneNumber) => {
  navigator.clipboard.writeText(phoneNumber).then(function () {
    phoneCopied.value = true;
    const to = setTimeout(() => {
      phoneCopied.value = false;
      clearTimeout(to);
    }, 3000);
  }, function (err) {
    console.error('Async: Could not copy text: ', err);
  });
};

const goToLink = (link) => {
  window.open(link, '_blank');
};

useSeoMeta({
  ogUrl: () => `https://impacthink.id/${selectedUser.value?.slug}`,
  title: () => `${selectedUser.value?.name} - ImpacThink`,
  ogTitle: () => `${selectedUser.value?.name} - ImpacThink`,
  twitterTitle: () => `${selectedUser.value?.name} - ImpacThink`,
  description: () => `Welcome to ${selectedUser.value?.name} from ImpacThink `,
  ogDescription: () => `Welcome to ${selectedUser.value?.name} from ImpacThink `,
  twitterDescription: () => `Welcome to ${selectedUser.value?.name} from ImpacThink `,
  ogImage: '/favicon.ico',
  twitterImage: '/favicon.ico',
  twitterCard: 'summary',
});

onMounted(() => {
  if (!selectedUser.value) {
    // router.push({ name: 'fallback-page' });
    // throw createError({ statusCode: 404, statusMessage: 'Page Not Found' });
    throw createError({
      statusCode: 404,
      fatal: true,
    });
  }

  if (navigator.userAgent.includes('Instagram')) {
    isInstagramBrowser.value = true;
  }
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent) && !window.MSStream) {
    isIphoneDevice.value = true;
  }

  $anime({
    targets: '.profile-graphic',
    opacity: 1,
    translateY: [100, 0],
    translateX: [-100, 0],
    delay: $anime.stagger(100),
    easing: 'easeInOutQuart',
    duration: 700,
  });

  $anime({
    targets: '.profile-item',
    opacity: 1,
    translateY: [20, 0],
    delay: $anime.stagger(100),
    duration: 800,
  });
});
</script>

<style lang="scss" scoped>

</style>
